import React from "react";

const Team = ({ name, avatar, id }) => {
  return (
    <div className="checkbox-container">
      <img src={avatar} className="team-avater" alt={name} />
      <p className="label">{name}</p>
    </div>
  );
};

export default Team;
